import useFetchResource from '../useFetchResource';
import api from 'libs/api';

export interface IPublicAccount {
  id: number;
  name: string;
  subdomain: string;
  parking_unit_must_provided: boolean;
  parking_can_reservation_days: number;
  parking_public_reservation: boolean;
  parking_time_limit?: number;
  location_country_id: number;
}

export default function useGetPublicAccount(guid?: string) {
  const {
    resource: account,
    fetchResource: fetchAccount,
    isLoading,
  } = useFetchResource<IPublicAccount>({
    api: api.account.public,
    initialParams: { guid },
    initialValues: {
      id: 0,
      name: '',
      subdomain: '',
      parking_public_reservation: true,
      parking_unit_must_provided: false,
      parking_can_reservation_days: 0,
      location_country_id: 0,
    },
  });

  return { account, fetchAccount, isLoading };
}
